<mcg-loader [message]="translate('Guardando')" [showLoader]="isSaving"></mcg-loader>
<jqxWindow #opcionesWindow [width]="300" [height]="250" [theme]="theme" [showCloseButton]="true" [autoOpen]="true"
    [title]="translate('Instalaciones')">

    <div class="formHeader" style="overflow-x: hidden;"></div>
    <div class="form" style="float:left; overflow-x: hidden; ">
        <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
            <div style="display: flex; flex-direction: column; gap: 2px;">
                <div>
                    <jqxCheckBox #checkTag (onChange)="actualizarOpciones(InstallationTypes.TAG)">
                        {{translate('Requiere_instalacion')}} {{translate('Tag')}}
                    </jqxCheckBox>
                </div>

                <div>
                    <jqxCheckBox #checkVolumetrico (onChange)="actualizarOpciones(InstallationTypes.VOLUMETRIC)">
                        {{translate('Requiere_instalacion')}} {{translate('Volumetrico')}}
                    </jqxCheckBox>
                </div>

                <div>
                    <jqxCheckBox #checkCerraduraGeneral (onChange)="actualizarOpciones(InstallationTypes.LOCK)"
                        [disabled]="!obtenerValorCheckBox(InstallationTypes.IDENTIFIER)">
                        {{translate('Requiere_instalacion')}} {{translate('Cerradura')}}
                    </jqxCheckBox>
                </div>

                <div>
                    <jqxCheckBox #checkIdentificacion (onChange)="actualizarOpciones(InstallationTypes.IDENTIFIER)">
                        {{translate('Requiere_instalacion')}} {{translate('Identificacion') }}
                    </jqxCheckBox>
                </div>
            </div>

            <div>
                <label>Observaciones:</label>
                <textarea [(ngModel)]="observaciones" style="width: 100%; height: 100%;"></textarea>
            </div>

            <div style="display: flex; gap: 2px;">
                <jqxButton (onClick)="saveOptionsInstall()" width="100%">Guardar</jqxButton>
                <jqxButton (onClick)="cerrarOpciones()" width="100%">Cancelar</jqxButton>
            </div>
        </div>
    </div>
</jqxWindow>